<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h3>Project Types</h3>
      </div>
      <div class="card-body">
        <validation-observer ref="simpleRules">
          <b-form>
            <b-row v-for="(value, key) in projectTypes">
              <b-col md="4">
                <b-form-group>
                  <label for="name">Name «<span class="text-muted">English</span>»</label>
                  <validation-provider
                    #default="{ errors }"
                    name="English Name"
                    rules="required"
                  >
                    <b-form-input
                      id="name"
                      v-model="projectTypesTemp[key].name"
                      name="name"
                      :state="errors.length > 0 ? false:null"
                      placeholder=""
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="nameAR">Name «<span class="text-muted">Arabic</span>»</label>
                  <validation-provider
                    #default="{ errors }"
                    name="Arabic Name"
                    rules="required"
                  >
                    <b-form-input
                      id="nameAR"
                      v-model="projectTypesTemp[key].nameAR"
                      name="nameAR"
                      class="arabic-font"
                      :state="errors.length > 0 ? false:null"
                      placeholder=""
                      dir="rtl"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <button
                  type="button"
                  class="btn btn-outline-primary mt-2"
                  @click.prevent="validationForm(key)"
                >
                  <feather-icon
                    icon="Edit2Icon"
                    class="mr-25"
                  />
                  Update
                </button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        <h3>Project Status</h3>
      </div>
      <div class="card-body">
        <validation-observer ref="simpleRulesStatus">
          <b-form>
            <b-row v-for="(status, index) in projectStatus">
              <b-col md="4">
                <b-form-group>
                  <label for="name_en">Name «<span class="text-muted">English</span>»</label>
                  <validation-provider
                    #default="{ errors }"
                    name="English Name"
                    rules="required"
                  >
                    <b-form-input
                      id="name_en"
                      v-model="projectStatusTemp[index].name"
                      name="name_en"
                      :state="errors.length > 0 ? false:null"
                      placeholder=""
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="name_ar">Name «<span class="text-muted">Arabic</span>»</label>
                  <validation-provider
                    #default="{ errors }"
                    name="Arabic Name"
                    rules="required"
                  >
                    <b-form-input
                      id="name_ar"
                      v-model="projectStatusTemp[index].nameAR"
                      name="name_ar"
                      class="arabic-font"
                      :state="errors.length > 0 ? false:null"
                      placeholder=""
                      dir="rtl"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <button
                  type="button"
                  class="btn btn-outline-primary mt-2"
                  @click.prevent="validationFormStatus(index)"
                >
                  <feather-icon
                    icon="Edit2Icon"
                    class="mr-25"
                  />
                  Update
                </button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol,
} from 'bootstrap-vue'

import { codeBasic } from './code'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import projectTypesService from '@/services/settings/projectTypesService'
import projectStatusService from '@/services/settings/projectStatusService'

import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,

  },
  data() {
    return {
      loading: false,
      projectTypes: [],
      projectTypesTemp: [],
      projectStatus: [],
      projectStatusTemp: [],
      updatedProjectType: {
        name: '',
        nameAR: '',
      },
    }
  },
  mounted() {
    this.getProjectTypes()
    this.getProjectStatus()
  },
  methods: {
    getProjectTypes() {
      this.loading = true
      projectTypesService.index().then(response => {
        this.loading = false
        this.projectTypes = response.data.data
        this.projectTypesTemp = this.projectTypes
      })
    },
    getProjectStatus() {
      this.loading = true
      projectStatusService.index().then(response => {
        this.loading = false
        this.projectStatus = response.data.data
        this.projectStatusTemp = this.projectStatus
      })
    },
    validationFormStatus(index) {
      this.loading = true
      this.$refs.simpleRulesStatus.validate().then(success => {
        if (success) {
          projectStatusService.put(this.projectStatusTemp[index])
            .then(response => {
              this.getProjectStatus()
              if (response && response.status === 200) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'Success',
                    icon: 'CheckIcon',
                    variant: 'success',
                    text: 'Project Status Is Updated Successfully !',
                  },
                })
              }

              this.loading = false
            })
        }
      })
    },
    validationForm(index) {
      this.loading = true
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          console.log('index', index)
          console.log('projectTypesTemp[index]', this.projectTypesTemp[index])
          projectTypesService.put(this.projectTypesTemp[index])
            .then(response => {
              this.getProjectTypes()
              if (response && response.status === 200) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'Success',
                    icon: 'CheckIcon',
                    variant: 'success',
                    text: 'Project Type Is Updated Successfully !',
                  },
                })
              }

              this.loading = false
            })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
